import React, { useEffect, useState } from "react";
import { getAppDomain } from "../../utils/helper";
import { rootReducersState } from "../../reducers";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Button, EmployHERName, FlashMessage } from "../../components/common";
import _ from "lodash";
import candidateServices from "../../services/candidate.services";
import { candidateVisibilityStatus } from "../../utils/appConstants";
import {
  updateCandidateVisibilityRequest,
  updateCandidateSlug,
} from "../../reducers/auth/session.reducer";
import unknownProfile from "../../assets/images/unknownProfile.jpeg";
import moment from "moment";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { FormControlLabel } from "@material-ui/core";
import PenSVG from "../../assets/svg/PenSVG";
import useSessionUser from "../../hooks/useSessionUser";
import Avatar from "../../components/common/AvtarImage";

const ProfileAndVisibility = () => {
  const { handleSubmit, clearErrors } = useForm({});
  const [profileStatus, setProfileStatus] = useState<string>("public");
  const [slug, setSlug] = useState<string>("");
  const [btnState, setBtnState] = useState<boolean>(false);
  const dispatch = useDispatch();
  const appDomainFull = getAppDomain({ protocol: true });
  const { currentSlug } = useSessionUser();

  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session.currentUser
  );


  useEffect(() => {
    setSlug(currentSlug);
    let visible = sessionReducer.profile_visibility;
    let keyVal = visible === 2 ? "private" : visible === 0 ? "connections" : "public";
    setProfileStatus(keyVal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exitTextBox = () => {
    setBtnState(false);
    setSlug(slug);
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Escape" && btnState) {
        event.preventDefault();

        exitTextBox();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [btnState]);

  const onSubmit = async () => {
    console.log(profileStatus, 'profileStatus');
    if (!btnState) {
      try {
        const result = await candidateServices.updateCandidateVisibility({
          visibility: candidateVisibilityStatus[profileStatus],
        });

        if (result.flag) {
          dispatch(
            updateCandidateVisibilityRequest(
              candidateVisibilityStatus[profileStatus]
            )
          );
          FlashMessage(result.message, "success");
        } else {
          FlashMessage(result.message, "error");
        }
      } catch (error) {
        FlashMessage(error?.message, "error");
      }
    }
  };

  const editSlug = (e) => {
    setBtnState(true);
  };

  const onClickEnter = async (e) => {
    setBtnState(true);

    const regex = /^\w[a-zA-Z0-9-]{2,50}$/;

    if (e.code === "Enter" || e.code === "NumpadEnter") {
      if (regex.test(slug)) {
        try {
          if (slug !== currentSlug) {
            const result = await candidateServices.updateSlug({
              slug,
            });

            if (result.flag) {
              setSlug(slug);

              dispatch(updateCandidateSlug(slug));
              FlashMessage(result.message, "success");
            } else {
              setSlug(currentSlug);
              FlashMessage(result.message, "error");
            }
          }
        } catch (error) {
          setSlug(currentSlug);
          FlashMessage(error?.message, "error");
        }
      } else {
        FlashMessage("Please enter valid slug", "error");
        setSlug(_.get(sessionReducer, "slug", ""));
      }
    }
  };

  return (
    <div className="profile-container">
      <div className="settings-header">
        <h3 className="title">Profile and visibility</h3>
        <p className="font-md">
          Mange your personal information. From here, you have control over who
          can sees your profile information on Employher.
        </p>
      </div>
      <div className="profile-info-wrapper">
        <div className="profile-info-main-wrapper">
          <Avatar
            src={_.get(sessionReducer, "profile_image", unknownProfile)}
          />
          <div className="profile-info-text">
            <b>
              {_.get(sessionReducer, "first_name", "")}{" "}
              {_.get(sessionReducer, "last_name", "")}
            </b>{" "}
            <span>{_.get(sessionReducer, "email", "")}</span>
          </div>
        </div>
        <div className="profile-info-date font-md">
          <span className="font-bold-600">Account created at</span>{" "}
          {moment(_.get(sessionReducer, "created_at", Date())).format(
            "D MMM, YYYY | hh:mm A"
          )}
        </div>
      </div>

      <div className="profile-settings-wrapper">
        <p className="font-md">Control who can search you on employ<span className="title">HER</span>?</p>
        <form
          onSubmit={(e) => {
            clearErrors();
            setBtnState(false);
            handleSubmit(onSubmit)(e);
          }}
          className="edit-modal-wrapper"
        >
          <div className="form-group">
            <RadioGroup
              value={profileStatus}
              onChange={(e: React.ChangeEvent<any>) => {
                setProfileStatus(_.get(e, "target.value", ""));
              }}
            >
              <FormControlLabel
                value="public"
                control={<Radio />}
                label={<span>Anyone on <EmployHERName /></span>}
              />
              <FormControlLabel
                value="connections"
                control={<Radio />}
                label="Connections only"
              />
              <FormControlLabel
                value="private"
                control={<Radio />}
                label="Only me"
              />
            </RadioGroup>
            <div className="form-group btn-group btn-right btn-submit">
              <Button type="submit" color="primary">
                Save
              </Button>
            </div>
          </div>
          <hr />
          <div className="profile-url-wrapper">
            <div className="settings-header">
              <h3>Personalize the URL for your profile</h3>
              <p className="font-md">
                Your custom URL must contain 3-50 letters, numbers or dash. Please
                do not use spaces, symbols, or special characters.
              </p>
            </div>
            <div className={`profile-url-input-wrapper ${btnState ? "btn-state-active" : ""}`}>
              {appDomainFull}profile/view/
              {!btnState && <span>{_.get(sessionReducer, "slug", "")} </span>}
              <span
                onKeyPress={(e) => {
                  onClickEnter(e);
                }}
              >
                <input
                  type="text"
                  className="slug-input"
                  value={slug}
                  hidden={!btnState}
                  onChange={(e) => {
                    setSlug(e.target.value);
                  }}
                />
              </span>
              <span
                onClick={editSlug}
                hidden={btnState}
                className="cursor-pointer edit-pencil-icon"
              >
                <PenSVG />
              </span>
            </div>
            {btnState && (
              <span className="profile-url-input-helper-text">Press enter to save or escape to cancel the action.</span>
            )}
          </div>


        </form>
      </div>
    </div>
  );
};

export default ProfileAndVisibility;
